<template>
  <div id="Login">
    <!-- <div class="Login_title"><img src="../assets/img/logint.png" alt="" /></div> -->
    <div class="Login_title">
      <p>孝佰汇后台管理系统</p>
    </div>
    <div class="Login_main">
      <div class="loginform">
        <div class="formindex" @keydown.enter="Login()">
          <form action="">
            <el-input placeholder="请输入账号" v-model.trim="account">
              <i slot="prefix" class="el-input__icon el-icon-user"></i>
            </el-input>
            <el-input placeholder="请输入密码" v-model.trim="pwd" show-password>
              <i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
            <el-checkbox v-model="checked">记住密码</el-checkbox>
          </form>
          <el-button type="primary" @click="Login()">登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userlogin } from "../axiosAPI";
export default {
  name: "Login",
  data() {
    return {
      account: "",
      pwd: "",
      checked: false,
    };
  },

  mounted() {
    this.AutoFill();
  },
  methods: {
    //   登录
    Login() {
      if (this.account == "") {
        this.$message({
          message: "请输入账号",
          type: "error",
        });
        return;
      }
      if (this.pwd == "") {
        this.$message({
          message: "请输入密码",
          type: "error",
        });
        return;
      }
      const query = this.$qs.stringify({
        username: this.account,
        password: this.pwd,
      });
      userlogin(query).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: "登录成功",
            type: "success",
          });
          sessionStorage.setItem("axData", JSON.stringify(res.data.item));
          this.$router.push({ path: "/Manager" });
          if (this.checked) {
            this.$cookie.set("axAccount", this.account, 3);
            this.$cookie.set("axPwd", this.pwd, 3);
            this.$cookie.set("axChecked", this.checked, 3);
          } else {
            this.$cookie.delete("axAccount");
            this.$cookie.delete("axPwd");
            this.$cookie.delete("axChecked");
          }
        } else {
          this.$message({
            message: "账号或密码错误",
            type: "error",
          });
        }
      });
    },
    // 勾选记住密码 下次自动填写
    AutoFill() {
      this.account = this.$cookie.get("axAccount");
      this.pwd = this.$cookie.get("axPwd");
      this.checked = Boolean(this.$cookie.get("axChecked"));
    },
  },
};
</script>

<style lang="less" scoped>
#Login {
  width: 100vw;
  height: 100vh;
  background: url(../assets/img/loginbg.jpg);
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .Login_title {
    margin-bottom: 0.5rem;
    p {
      color: #fff;
      zoom: 0.6;
    }
  }
  .Login_main {
    width: 40%;
    height: 5rem;
    background-color: #fff;
    display: flex;
    justify-content: center;
    .loginform {
      width: 50%;
      height: 70%;
      .formindex {
        width: 100%;
        margin-top: 0.2rem;

        /deep/ .el-input {
          margin: -0.8rem 0;
        }
        /deep/ .el-input.is-active .el-input__inner,
        /deep/ .el-input__inner:focus {
          border-color: #f7c0ae;
        }

        /deep/ .el-button {
          width: 100%;
          background-color: #f7c0ae;
          border-color: #f7c0ae;
        }
        /deep/ .el-button--primary:focus,
        /deep/ .el-button--primary:hover,
        /deep/ .el-button--primary:active {
          background-color: #f7c0ae;
          border-color: #f7c0ae;
        }
      }
    }
  }
}
</style>
<style lang="less">
.el-message {
  font-size: 20px;
}
.el-checkbox {
  margin-left: 0.2rem;
}
// 多选框
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f7c0ae !important;
  border: 1px solid #f7c0ae !important;
}
.el-checkbox__inner:hover {
  border-color: #f7c0ae;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #f7c0ae;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #f7c0ae !important;
}
</style>
